import { Component, OnInit } from '@angular/core';

declare let require: any;
@Component({
  selector: 'app-school-not-found',
  templateUrl: './school-not-found.component.html',
  styleUrls: ['./school-not-found.component.css'],
  standalone: false
})
export class SchoolNotFoundComponent implements OnInit {

  ngOnInit() {
    try {
      require('../../_services/adobe404.js');
    } catch (error) {
      console.log(error);
    }
  }

}
